import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	showMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showLess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showMore: {
		id: 'issue-create.modal.create-form.type-picker.request-type-help-text.show-more',
		defaultMessage: 'Show more…',
		description:
			'Button text to toggle showing the full request type help text when it is too large to fit 2 lines.',
	},
	showLess: {
		id: 'issue-create.modal.create-form.type-picker.request-type-help-text.show-less',
		defaultMessage: 'Show less…',
		description:
			'Button text to toggle hiding the full request type help text when it is too large to fit 2 lines.',
	},
});
export default messages;
